var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17.5,
    fill: "white",
    stroke: "#6921C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8529 25.075C15.2102 25.4323 15.7862 25.4323 16.1435 25.075L22.2029 19.0156C22.4872 18.7312 22.4872 18.2719 22.2029 17.9875L16.1435 11.9281C15.7862 11.5708 15.2102 11.5708 14.8529 11.9281C14.4956 12.2854 14.4956 12.8615 14.8529 13.2188L20.132 18.5052L14.8456 23.7917C14.4956 24.1417 14.4956 24.725 14.8529 25.075Z",
    fill: "#6921C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewListIcon);
export default __webpack_public_path__ + "static/media/viewListIcon.173ffb48.svg";
export { ForwardRef as ReactComponent };